import React from 'react';
import ReactDOM from 'react-dom/client';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import './index.css';
import App from './App';
import { BrowserRouter } from "react-router-dom";
import './i18n';
import { Provider } from 'react-redux';
import store from './app/store';
import { setupInterceptors } from './modules/shared/api/axios';
import MobileRuntimeBridge from './components/MobileRuntimeBridge';
import SingleSubmitGuard from './components/SingleSubmitGuard';
import AppErrorBoundary from './components/AppErrorBoundary';
import { installClientIncidentHandlers } from './modules/shared/services/clientIncidents';
setupInterceptors(store.dispatch);
installClientIncidentHandlers();

if (Capacitor.isNativePlatform()) {
  StatusBar.setOverlaysWebView({ overlay: true }).catch(() => {});
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AppErrorBoundary>
    <Provider store={store}>
      <BrowserRouter>
        <SingleSubmitGuard />
        <MobileRuntimeBridge />
        <App />
      </BrowserRouter>
    </Provider>
  </AppErrorBoundary>
);
